import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import amazon from "../../Assets/Projects/amazon.png";
import clock from "../../Assets/Projects/clock.png";
import clpl from "../../Assets/Projects/clpl.jpg";
import disney from "../../Assets/Projects/disney.png";
import face from "../../Assets/Projects/faceapp.png";
import fb from "../../Assets/Projects/fb-clone.png";
import iot from "../../Assets/Projects/iot.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import robo from "../../Assets/Projects/robots.png";
import todo from "../../Assets/Projects/todo.png";
import weather from "../../Assets/Projects/weather.png";
import web from "../../Assets/Projects/clplweb.png";
import whatsapp from "../../Assets/Projects/whatsapp.png";
import uber from "../../Assets/Projects/uber.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Work </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've done recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={uber}
              isBlog={false}
              title="Uber Clone"
              description="Responsive Uber clone webapp. Developed using NextJS, Sanity.io,Tailwind, Ether.js and Metamask Authentication."
              link="https://uber-dev1110.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={disney}
              isBlog={false}
              title="Disney Clone"
              description="Responsive Disney clone webapp. Developed using ReactJS, Redux, Styled Components, Firestore Database and Google Authentication."
              link="https://disney-dev1110.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={amazon}
              isBlog={false}
              title="Amazon Clone"
              description="Responsive Amazon clone webapp. Developed using ReactJS, Firestore Database and Google Authentication."
              link="https://j-5d224.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather"
              description="Check the current weather at your specified city name."
              link="https://weather-lata-clabs.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Todo"
              description="Create a list of tasks for your day with this app."
              link="https://todo-lata-clabs.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={clock}
              isBlog={false}
              title="Clock"
              description="A simple clock app created with reactjs."
              link="https://clock-lata-clabs.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={whatsapp}
              isBlog={false}
              title="Whatsapp Clone"
              description="This is a whatsapp clone webapp. Developed using ReactJS, Firestore Database and Google Authentication."
              link="https://whatsapp-1110.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fb}
              isBlog={false}
              title="Facebook Clone"
              description="This is a facebook clone webapp. Developed using ReactJS, Firestore Database and Google Authentication."
              link="https://fb-clone-805ef.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={iot}
              isBlog={false}
              title="IOT App"
              description="The webapp gets data from a temperature sensing machine and save different sensor's status into the database. Build with react node and express js."
              link="http://cyberlabsweb.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={clpl}
              isBlog={false}
              title="Company Portfolio"
              description=" This is a company portfolio website designed with wordpress."
              link="http://cyberlabs.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={web}
              isBlog={false}
              title="Employee Management System"
              description=" This app keeps the record of employee's daily beverage bill. "
              link="http://cyberlabsweb.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={robo}
              isBlog={false}
              title="Robots"
              description="A fun app build with react.js and API with a search box. You can search through the available robo friends."
              link="http://cyberlabspvtltd.com/robots"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={face}
              isBlog={false}
              title="Face Detection"
              description=" This app is build with react.js, node.js and Express.js using a face detection api. User can signup and detect 
              a face in the image. User has to put the image url in the field and app will detect the face with 90.1% accuracy."
              link="http://cyberlabspvtltd.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="My Portfolio"
              description="My personal portfolio page build with React.js and Hooks."
              link="https://lata-portfolio.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
